var GoogleRecaptcha = function () {// eslint-disable-line no-unused-vars
    var apiKey = $('#mi-corpo-contact-form-google-recaptcha').val();

    var resultDomElement;
    var widgetId;

    function initializeCallback (key, result, id) {
        apiKey = key;
        resultDomElement = result;
        widgetId = id;
    }

    var captchaCallback = function(resultDomElement, widgetId) {
        if (grecaptcha.getResponse(widgetId) !== '') {// eslint-disable-line no-undef
            $(resultDomElement).val('valid');
        }
    };

    return {

        initialize: function (apiKey, resultDomElement, widgetId) {
            initializeCallback(apiKey, resultDomElement, widgetId);
        },

        onloadCallback: function () {
            var recaptchas = document.querySelectorAll('div[class=g-recaptcha]');
            // ToDo: Change API Key
            var widget = grecaptcha.render(recaptchas[widgetId].id, {// eslint-disable-line no-undef, no-unused-vars
                'sitekey': apiKey,
                'callback': function () {
                    return captchaCallback(resultDomElement, widgetId);
                }
            });
        }
    };

};
